<template>
  <div class="info-content">
    <p class="title">物业信息</p>
    <div class="company-info">
      <div class="img">
        <img style="height:100px" src="~@/assets/image/company-logo.png" alt="">
      </div>
      <div class="detail">
        <p class="company-name">{{ companyName }}</p>
        <p class="tel">{{ tel }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'companyInfo',
  props: {
    companyName: String,
    tel: String
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.info-content {
  margin-bottom: 8px;
  width: 100%;
  height: 150px;
  text-align: left;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 12px;
  }
  .company-info {
    display: flex;
  }
  .detail {
    padding-left: 16px;
    box-sizing: border-box;
    .company-name {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    .tel {
      font-size: 14px;
    }
  }
}
</style>